<template>
<div v-loading="loadingProgress" element-loading-text="Loading..." style="padding:10px;margin-left:40px;min-height:100px;background-color:#f5f5f5" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
       <div v-if="!loadingProgress"><h5> Clock Hours (complete/total) :{{Math.round(customer.enrollments[0].product.hours * ( progress.reduce((total, course) => total + parseInt(course.enrollmentCurrentPoints),0)/ progress.reduce((total, course) => total + parseInt(course.courseMaximumPoints),0) ))}}/{{customer.enrollments[0].product.hours}}</h5></div>

   <p v-if="tutor.firstname">Tutor: {{tutor.firstname}} {{tutor.lastname}}</p>
   
   <div v-for="(course,idx) in progress" v-show="!loadingProgress" v-bind:key="idx">
         <el-popover
    placement="top-start"
    
    width="400"
    trigger="hover"
  >

  <h3>{{course.courseName}}</h3>
  <ul style="list-style-type: none;padding:5px;background-color:#f5f5f5">
  <li v-for="(lesson,idx) in course.lessons" v-bind:key="idx">
   {{lesson.name}} {{lesson.currentPoints}}/{{lesson.maximumPoints}}
 <el-progress :percentage="Math.round((lesson.currentPoints/lesson.maximumPoints)*100)"></el-progress>

  </li>
  </ul>
   <el-progress
   slot="reference"
            :stroke-width="20"
            :loading="loadingProgress"
            :text-inside="true"
            :percentage="Math.round((course.enrollmentCurrentPoints/course.courseMaximumPoints)*100)"
          ></el-progress>
  </el-popover>
          
          {{course.courseName}} - {{course.enrollmentStatus}}
        </div>
  
         
</div>
</template>
<script>
import LMSapi from "../../../api/lmsAPI";

export default {
  props: ["customer"],
  data() {
    return {
      loadingProgress: false,
        progress: [],
        tutor:''
    };
  },
  components: {},
  methods: {
    getLMSProgress(email) {
      this.loadingProgress = true;
      const progress = LMSapi.getProgress(email);
      const tutor =  LMSapi.getTutor(email);
      Promise.all([progress,tutor])
        .then(([result,res]) => {
          this.progress = result.data.data;
          this.loadingProgress = false;
          this.tutor=res.data.data
        })
        .catch(e => {
          this.$notify({
            title: "Error",
            message: "This user has no enrollments",
            type: "error"
          });
        });
         
    }
  },
  created(){
    console.log('mounted')
this.getLMSProgress(this.customer.email)
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerProfile/LMSProgress.vue